import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = ["data-testid"]
const _hoisted_3 = ["data-testid"]

import { computed } from 'vue'

import { packageClock } from '../format'
import type { PackageClockInput } from '../format'
import { AFFILIATE_SLA_TEXT_CLASS } from '../labels'


export default /*#__PURE__*/_defineComponent({
  __name: 'AffiliatePackageClock',
  props: {
    row: {},
    nowMs: {},
    size: { default: 'md' },
    testId: { default: 'affiliate-package-clock' }
  },
  setup(__props: any) {

const props = __props;



const clock = computed(() => packageClock(props.row, props.nowMs))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex min-w-0 flex-col",
    "data-testid": _ctx.testId
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(["font-mono font-bold leading-none tabular-nums", [_ctx.size === 'lg' ? 'text-2xl' : 'text-lg', _unref(AFFILIATE_SLA_TEXT_CLASS)[clock.value.tone]]]),
      "data-testid": `${_ctx.testId}-value`
    }, _toDisplayString(clock.value.value), 11, _hoisted_2),
    (clock.value.due)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "mt-1 text-[11px] text-neutral50",
          "data-testid": `${_ctx.testId}-due`
        }, _toDisplayString(clock.value.due), 9, _hoisted_3))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})